"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReaderPreferencesProvider = exports.ReaderPreferencesContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _EpubReaderContext = require("./EpubReaderContext");
var _HighlightsContext = require("./HighlightsContext");
var _BookmarksContext = require("./BookmarksContext");
var _services = require("../services");
var _themes = require("../themes");
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable no-console */ // Contexts
// Services
// Themes
var ReaderPreferencesContext = exports.ReaderPreferencesContext = /*#__PURE__*/(0, _react.createContext)();
var ReaderPreferencesProvider = _ref => {
  var {
    children
  } = _ref;
  var [fontButton, setFontButton] = (0, _react.useState)({
    fontSize: 20,
    fontPercentageValue: 100,
    disableDecreaseButton: false,
    disableIncreaseButton: false
  });
  var [columnType, setColumnType] = (0, _react.useState)('one');
  var [backgroundStyle, setBackgroundStyle] = (0, _react.useState)('default');
  var {
    rendition,
    applicationToken,
    sessionToken,
    userId,
    cfi,
    jumpToPage,
    setCurrentLocation,
    setCurrentEndLocation
  } = (0, _react.useContext)(_EpubReaderContext.EpubReaderContext);
  var {
    repaintHighlight
  } = (0, _react.useContext)(_HighlightsContext.HighlightsContext);
  var {
    bookmarks,
    setIsPageBookmarked
  } = (0, _react.useContext)(_BookmarksContext.BookmarksContext);
  var appToken = (0, _utils.appTokenCase)(window.location.origin);
  var trackService = (0, _services.TrackingsService)(appToken, sessionToken);
  (0, _react.useEffect)(() => {
    if (!rendition) {
      return;
    }
    rendition.themes.register('default', _themes.defaultTheme);
    rendition.themes.register('dark', _themes.EPUB_READER_THEMES.dark);
    rendition.themes.register('sepia', _themes.sepiaTheme);
    rendition.themes.register('brighter', _themes.brighterTheme);
  }, [rendition]);
  (0, _react.useEffect)(() => {
    var _rendition$currentLoc;
    if (!cfi || !(rendition !== null && rendition !== void 0 && (_rendition$currentLoc = rendition.currentLocation()) !== null && _rendition$currentLoc !== void 0 && (_rendition$currentLoc = _rendition$currentLoc.start) !== null && _rendition$currentLoc !== void 0 && _rendition$currentLoc.cfi)) return;
    var bookmarked;
    if (bookmarks.length === 0) {
      bookmarked = false;
    } else {
      bookmarked = bookmarks.some(bookmark => rendition.book.locations.locationFromCfi(bookmark.cfi) === rendition.book.locations.locationFromCfi(rendition.currentLocation().start.cfi));
    }
    setIsPageBookmarked(bookmarked);
  }, [cfi, bookmarks, rendition, setIsPageBookmarked, fontButton]);
  var savePreferences = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (settings) {
      try {
        var service = (0, _services.ReaderPreferencesService)(applicationToken, sessionToken);
        var response = yield service.updateUserPreferences(userId, settings);
        if (!response.ok) {
          var error = yield response.json();
          throw error;
        }
      } catch (error) {
        console.error(error);
        console.log('Não foi possível salvar as preferências.');
      }
    });
    return function savePreferences(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var increaseFont = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* () {
      var newFontSize = fontButton.fontSize + 2;
      var newPercentage = fontButton.fontPercentageValue + 10;
      var disableIncrease = false;
      if (newPercentage === 200) {
        disableIncrease = true;
      }
      yield rendition.themes.fontSize("".concat(newFontSize, "px"));
      setFontButton({
        fontSize: newFontSize,
        fontPercentageValue: newPercentage,
        disableDecreaseButton: false,
        disableIncreaseButton: disableIncrease
      });
      savePreferences({
        font_size: newFontSize,
        background_style: backgroundStyle,
        columns: columnType
      });
      trackService.trackChangeFontSize(newPercentage);
      repaintHighlight(rendition);
      setCurrentLocation(rendition.currentLocation().start.location);
      setCurrentEndLocation(rendition.currentLocation().end.location);
    });
    return function increaseFont() {
      return _ref3.apply(this, arguments);
    };
  }();
  var decreaseFont = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(function* () {
      var newFontSize = fontButton.fontSize - 2;
      var newPercentage = fontButton.fontPercentageValue - 10;
      var disableDecrease = false;
      if (newPercentage === 10) {
        disableDecrease = true;
      }
      yield rendition.themes.fontSize("".concat(newFontSize, "px"));
      setFontButton({
        fontSize: newFontSize,
        fontPercentageValue: newPercentage,
        disableDecreaseButton: disableDecrease,
        disableIncreaseButton: false
      });
      savePreferences({
        font_size: newFontSize,
        background_style: backgroundStyle,
        columns: columnType
      });
      trackService.trackChangeFontSize(newPercentage);
      repaintHighlight(rendition);
      setCurrentLocation(rendition.currentLocation().start.location);
      setCurrentEndLocation(rendition.currentLocation().end.location);
    });
    return function decreaseFont() {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleColumnType = type => {
    setColumnType(type);
    savePreferences({
      font_size: fontButton.fontSize,
      background_style: backgroundStyle,
      columns: type
    });
    if (type === 'one') {
      rendition.spread('none');
      rendition.resize(680);
    } else {
      rendition.spread('auto');
      rendition.resize(1900);
    }
    trackService.trackChangeColumns(type);
  };
  var handleBackgroundStyle = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(function* (style) {
      var currentPage = rendition.location.start.cfi;
      setBackgroundStyle(style);
      savePreferences({
        font_size: fontButton.fontSize,
        background_style: style,
        columns: columnType
      });
      yield rendition.themes.select(style);
      yield rendition.clear();
      yield rendition.display(cfi);
      trackService.trackChangeBackgroundColor(style);
      repaintHighlight(rendition);
      setTimeout(() => {
        jumpToPage(currentPage);
      }, 10);
    });
    return function handleBackgroundStyle(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(ReaderPreferencesContext.Provider, {
    value: {
      fontButton,
      setFontButton,
      increaseFont,
      decreaseFont,
      backgroundStyle,
      setBackgroundStyle,
      handleBackgroundStyle,
      columnType,
      setColumnType,
      handleColumnType
    }
  }, children);
};
exports.ReaderPreferencesProvider = ReaderPreferencesProvider;
ReaderPreferencesProvider.propTypes = {
  children: _propTypes.default.node.isRequired
};